import { AnalyticsContextValue } from "@swiggy-private/analytics";
import { IMPRESSION_ACTIONS, SCREEN_NAME } from "@cart-client/analytics/constants";

export const impressionCartToast = (
    context: string,
    label: string,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_TOAST_MESSAGE,
        context,
        label,
    });
};
